function highlight(target, query, tag = 'mark') {
  if (!query) return target

  const start = target.toLowerCase().indexOf(query.toLowerCase())
  const end = start + query.length

  if (start < 0) return target

  const split = target.split``

  split.splice(end, 0, `</${ tag }>`)
  split.splice(start, 0, `<${ tag }>`)

  return split.join``
}

export default highlight
